export default {
  "hero": {
    "watch_video": "Watch our video",
    "image_src": "/images/hero/en-q-alem-da-qualidade.png"
  }
}
